import React from 'react';
import { useTranslation } from 'next-i18next';
import TextHeader, { SIZE, WEIGHT, TAG } from '@components/TextHeader';
import {
  Container,
  Wrapper,
  StyledSchedule,
  ScheduleWrapper,
  VerticalRule,
  Month,
  Deadline,
  Topic,
  Dot,
  TopSquare,
  BottomSquare,
  CompanyTile,
  MobileTile,
} from '@components/Internship/Schedule/styles';

function Schedule() {
  const { t } = useTranslation('internship');
  return (
    <Container>
      <Wrapper>
        <TextHeader size={SIZE.LG} weight={WEIGHT.NORMAL} tag={TAG.H2}>
          {t('Schedule')}
        </TextHeader>
        <StyledSchedule>
          <VerticalRule className="rule-schedule" />
          <ScheduleWrapper>
            <Month>
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H5}>
                {t('March')}
              </TextHeader>

              <Deadline className="mobileView dot">
                <Dot />
                do 04.03
              </Deadline>
              <Topic className="mobileView" dangerouslySetInnerHTML={{ __html: t('March desc') }} />
              <Deadline className="mobileView dot">
                <Dot />
                do 20.03
              </Deadline>
              <Topic className="mobileView" dangerouslySetInnerHTML={{ __html: t('March second desc') }} />
              <MobileTile>
                <TextHeader size={SIZE.XS} tag={TAG.H4} weight={WEIGHT.MEDIUM}>
                  {t('Promotion campaign')}
                </TextHeader>
                <p>20.03 - 20.04</p>
              </MobileTile>
              <Deadline className="mobileView dot">
                <Dot />
                23.03
              </Deadline>
              <Topic className="mobileView" dangerouslySetInnerHTML={{ __html: t('March third desc') }} />
            </Month>
            <Month className="mobileView">
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H5}>
                {t('April')}
              </TextHeader>
              <Deadline>
                <Dot />
                20.04
              </Deadline>
              <Topic dangerouslySetInnerHTML={{ __html: t('April desc') }} />
              <Deadline>
                <Dot />
                21.04
              </Deadline>
              <Topic dangerouslySetInnerHTML={{ __html: t('April second desc') }} />
            </Month>
            <Month>
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H6}>
                {t('May')}
              </TextHeader>
              <Deadline>
                <Dot />
                25.05
              </Deadline>
              <Topic dangerouslySetInnerHTML={{ __html: t('May desc') }} />

              <Deadline>
                <Dot />
                29.05
              </Deadline>
              <Topic dangerouslySetInnerHTML={{ __html: t('May second desc') }} />
            </Month>
            <Month>
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H6}>
                {t('June')}
              </TextHeader>
              <MobileTile>
                <TextHeader size={SIZE.XS} tag={TAG.H4} weight={WEIGHT.MEDIUM}>
                  {t('Internship at companies')}
                </TextHeader>
                <p>01.06 - 30.09</p>
              </MobileTile>
            </Month>
            <Month>
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H6}>
                {t('July')}
              </TextHeader>
            </Month>
            <Month>
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H6}>
                {t('August')}
              </TextHeader>
            </Month>
            <Month>
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H6}>
                {t('September')}
              </TextHeader>
            </Month>
            <Month className="padded">
              <TextHeader size={SIZE.XS} weight={WEIGHT.BOLD} tag={TAG.H5}>
                {t('October')}
              </TextHeader>

              <Topic dangerouslySetInnerHTML={{ __html: t('October desc') }} />
            </Month>

            <TopSquare className="schedule-box">
              <CompanyTile type="left">
                <TextHeader size={SIZE.XS} tag={TAG.H4} weight={WEIGHT.MEDIUM}>
                  {t('Promotion campaign')}
                </TextHeader>
                <p>20.03 - 20.04</p>
              </CompanyTile>
            </TopSquare>
            <BottomSquare className="schedule-box">
              <CompanyTile type="right">
                <TextHeader size={SIZE.XS} tag={TAG.H4} weight={WEIGHT.MEDIUM}>
                  {t('Internship at companies')}
                </TextHeader>
                <p>01.06 - 30.09</p>
              </CompanyTile>
            </BottomSquare>
          </ScheduleWrapper>
        </StyledSchedule>
      </Wrapper>
    </Container>
  );
}

export default Schedule;
